import React, { FC } from 'react';
import classes from './WinnersDialog.module.scss';
import Modal from './Modal';
import { PlayerDTO } from '@envclient/envcore/src/types/core';
import Button from './Button';

const WinnersDialog: FC<Props> = ({ winners, onClose, showPoints = true }) => {
  const isDraw = !winners || winners.length === 0;
  return (
    <Modal>
      <div className={classes.mainCont}>
        <div className={classes.bg}></div>
        <div className={classes.panel}>
          <div className={classes.header}>
            <div className={classes.title}>{isDraw ? "It's a draw!" : 'The winners are:'}</div>
          </div>
          <div className={classes.body}>
            {isDraw ? (
              <div className={classes.playerItem}>No winner — the game ended in a draw.</div>
            ) : (
              winners.map((p) => (
                <div className={classes.playerItem} key={p.id}>
                  {p.displayName}
                  {showPoints && ` : ${p.score} points`}
                </div>
              ))
            )}
          </div>
          <div className={classes.btnBar}>
            <Button onClick={() => onClose()}>OK</Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

interface Props {
  winners: PlayerDTO[];
  onClose: () => void;
  showPoints?: boolean;
}
export default WinnersDialog;
